// extracted by mini-css-extract-plugin
export default {"container":"TermsOfUse_container__uIBpW","title":"TermsOfUse_title__R0B2q","content":"TermsOfUse_content__FXh-r"};